import { render, staticRenderFns } from "./SupplierQuality.vue?vue&type=template&id=69c95c59&scoped=true&lang=true&"
import script from "./SupplierQuality.vue?vue&type=script&lang=js&"
export * from "./SupplierQuality.vue?vue&type=script&lang=js&"
import style0 from "./SupplierQuality.vue?vue&type=style&index=0&id=69c95c59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c95c59",
  null
  
)

export default component.exports